import { defaultHttpClient } from 'shared/src/api/httpClient';
import type {
  GetFavoriteMarketsParams,
  GetFavoriteMarketsResponse,
} from './types';

/**
 * - 내 찜한 마켓 전체 목록 (pagination)
 */
export const getFavoriteMarkets = async ({
  next_token,
}: GetFavoriteMarketsParams = {}) => {
  return defaultHttpClient
    .request<GetFavoriteMarketsResponse>({
      method: 'GET',
      url: '/api/v2/home/favorited_markets/me/',
      params: { next_token },
    })
    .then(result => result.data);
};
